import {TableControllerService} from "../../../../services/table-controller.service";
import {SpinnerService} from "../../../../services/spinner.service";
import {HttpParams} from "@angular/common/http";
import {ActionSet, Layout} from "../../../../models/layout";

/**
 * Column configuration for the data table
 */
export interface ColumnConfig
{
	id: string;
	columnName: string;
	columnLabel: string;
	columnPosition: number;
	type: ColumnType;
	isPk?: boolean;
	editable?: boolean;
	hidden?: boolean;
	maxLength?: number;
	patternInfo?: string;
	regExpList?: any[];
	optionValues?: OptionValue[];
	radioGroup?: string[];
	placeholder?: string;
	options?: any;
}

export type ColumnType =
	| 'DTY_NVAR'
	| 'DTY_INT'
	| 'DTY_FLOAT'
	| 'DTY_DATE'
	| 'DTY_TIME'
	| 'DTY_LIST'
	| 'DTY_YES_NO'
	| 'DTY_RADIO'
	| 'DTY_CUSTOM';

export interface OptionValue
{
	id: string;
	name: string;
}

/**
 * Row state flags
 */
export interface RowState
{
	editing?: boolean;
	newRow?: boolean;
	deleted?: boolean;
	edited?: boolean;
	checked?: boolean;
	backup?: any;
	errors?: Record<string, ColumnError>;
	isInnerTableVisible?: boolean;
	isChanged?: boolean;
}

export interface ColumnError
{
	error_type: 'DANGER' | 'WARNING' | 'INFO';
	error_list: string[];
}

/**
 * Action configuration
 */
export interface ActionConfig
{
	id: string;
	label?: string;
	icon?: string;
	disabled?: boolean;
	motivation?: string;
}

/**
 * Sorting configuration
 */
export interface SortConfig
{
	columnName: string;
	order: number;
	type: 'asc' | 'desc';
}

/**
 * Pagination configuration
 */
export interface PageConfig
{
	pageIndex: number;
	previousPageIndex: number;
	loader: number;
	size: number;
}

/**
 * Dataset configuration
 */
export interface DatasetConfig
{
	datas: ColumnConfig[];
	multiselect?: boolean;
}

export interface ComputedRowState
{
	isEditing: boolean;
	isCanceled: boolean;
}

/**
 * Action IDs used in the table
 */
export const ACTION_IDS = {
	// CRUD Actions
	ADD: 'ACT_ADD',
	EDIT: 'ACT_EDIT',
	DELETE_ID: 'ACT_DELETE_ID',
	SAVE: 'ACT_SAVE',
	SAVE_ID: 'ACT_SAVE_ID',
	EXIT_ROW: 'EXIT_ROW',//Undo

	// Bulk Actions
	EXPORT: 'ACT_EXPORT',
	IMPORT: 'ACT_IMPORT',
	DELETE: 'ACT_DELETE',

	// Special Actions
	EDIT_ALL: 'ACT_EDIT_ALL',
	SAVE_ALL: 'ACT_SAVE_ALL',
	INNER_TABLE: 'ACT_INNER_TABLE'
} as const;

export type ActionId = typeof ACTION_IDS[keyof typeof ACTION_IDS];

/**
 * Event payload emitted when an action is triggered
 */
export interface ActionEvent
{
	action: string;
	rowIndex: number;
	row?: any;
}

export interface CustomActionContext
{
	reloadData?: (extraParameters?: Map<string, string | number | boolean>) => void;
	reloadMainData?: () => void;
	row?: any;
	rowIndex?: number;
	tableController: TableControllerService;
	spinner: SpinnerService;
	apiUrl: string;
	apiParent: string;
	titlePage: string;
	savedParams: HttpParams;
	layout: Layout | undefined;
	pageId: string;
	actionsets?: ActionSet;

}
